import {Component, computed, effect, input, output, signal, WritableSignal} from '@angular/core';
import {ProtocolNoteService} from '../../../services/protocol/protocol-note.service';
import {ModalChangeEvent, Note, pEditorDefaultToolbarOptions} from '../../../../core/models/entities';
import {MessageUtilsService} from "../../../services/utils/message-utils.service";
import {SharedUtils} from "../../../services/utils/shared-utils.service";

@Component({
  selector: 'app-protocol-note-modal',
  templateUrl: './protocol-note-modal.component.html',
  styleUrl: './protocol-note-modal.component.scss'
})
export class ProtocolNoteModalComponent {
  toolbarOptions = pEditorDefaultToolbarOptions;
  modalChange = output<ModalChangeEvent>();
  editorContent: string = '';

  visible: WritableSignal<boolean> = signal(false);
  //current: WritableSignal<Note | null> = signal(null);
  protocolId = input.required<number>();
  current = computed(() => this.note() );
  note = input<Note | null>();
  show = input.required<boolean>();

  constructor(private noteService: ProtocolNoteService) {
    //può dare problemi?
    effect(() => this.editorContent = this.current() && this.current()?.note ? this.current()!.note : '' );
    effect(() => {
      if( this.show()){
        this.visible.set(this.show());
      }
    }, {allowSignalWrites: true});
  }

  save() {
    if(this.current() && this.current()?.id) {
      this.noteService.edit(this.protocolId(), this.returnContent(), this.current()!.id ).subscribe((res) => {
        this.postSave();
        });
      } else {
      this.noteService.create(this.protocolId(), this.returnContent()).subscribe((res) => {
        this.postSave();
      });
    }

  }

  private postSave() {
    SharedUtils.instance().messageUtils().push(MessageUtilsService.Severity.success, undefined, 'message.detail.saved');
    this.visible.set(false);
    this.modalChange.emit({reload: true, visible: false});
    this.editorContent = '';
  }

  private returnContent() {
    return this.editorContent  || '';
  }

  close(evt: MouseEvent) {
    this.visible.set(false);
    this.modalChange.emit({reload: false, visible: false});
    this.editorContent = '';
  }
}
